import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import FontAwesome from 'react-native-vector-icons/FontAwesome';

export const Container = styled.View`
  flex: 1;
  position: absolute;
`;

export const ModalContainer = styled.View``;

export const ModalContent = styled.View`
  background-color: ${({theme}) => theme.colors.background};

  border-radius: ${RFValue(20)}px;
  padding-bottom: ${RFValue(24)}px;
`;

export const CloseIconButton = styled.TouchableOpacity`
  position: absolute;
  top: ${RFValue(12)}px;
  right: ${RFValue(12)}px;
  z-index: 2;
`;

export const CloseIcon = styled(Feather)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.black};
`;

export const ModalHeader = styled.View`
  background-color: ${({theme}) => theme.colors.primary};
  padding: ${RFValue(24)}px;

  border-top-left-radius: ${RFValue(20)}px;
  border-top-right-radius: ${RFValue(20)}px;
`;
export const ModalHeadline = styled.Text`
  text-align: center;
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.bold};
`;
export const ModalBody = styled.View`
  padding: 0 ${RFValue(24)}px;
  margin-top: ${RFValue(16)}px;
`;
export const ModalTitle = styled.Text`
  text-align: center;
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-bottom: ${RFValue(12)}px;
`;

export const ModalText = styled.Text`
  text-align: center;
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const ModalFooter = styled.View`
  padding: 0 ${RFValue(24)}px;
  margin-top: ${RFValue(16)}px;
  justify-content: center;
`;

export const ButtonsContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
export const LikeButtonContainer = styled.TouchableOpacity`
  width: ${RFValue(50)}px;
  height: ${RFValue(50)}px;
  background-color: ${({theme}) => theme.colors.primary};
  justify-content: center;
  align-items: center;

  border-radius: ${RFValue(50)}px;
`;
export const Icon = styled(FontAwesome)`
  font-size: ${RFValue(22)}px;
  color: ${({theme}) => theme.colors.shape};
`;
